import { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";

import NoDataAvailable from "./NoDataAvailable";
import axiosHttp from "../config/axios.interceptor";
import UserListView from "./UserListView";
import Loader from "./Loader";
import {
  getFollowerSuggestion,
  getFollowersList,
} from "../store/actions/userActions";
import { errorResponseMessage, followerApiStatus } from "../shared/const.prop";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { AppContext } from "../contexts/AppContext";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
import RightSideBar from "./RightSibeBar";
import SuggestForYou from "./SuggestForYou";
import { useLocation } from "react-router-dom";

const ProfileActivity = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const cat = appContext.category;
  const [activeTab, setActiveTab] = useState("followers");
  const [loading, setLoading] = useState(true);
  const [followingList, setFollowingList] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [pendingList, setPendingList] = useState([]);
  const tabSwitchHandler = (event, tab) => {
    event.preventDefault();
    setActiveTab(tab);
  };

  useEffect(() => {
    fetchAllData();
  }, [cat]);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      await Promise.all([getMyFollowers(), getPending(), getFollowingsList()]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const getFollowingsList = async () => {
    try {
      const result = await axiosHttp.get(
        !cat ? `follow` : `follow?skillCategory=${cat}`
      );
      if (result.status === 200) {
        setFollowingList(result.data.data);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const getPending = async () => {
    try {
      const result = await axiosHttp.get(
        !cat ? `follow?status=R` : `follow?status=R&skillCategory=${cat}`
      );
      if (result.status === 200) {
        setPendingList(result.data.data);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const getMyFollowers = async () => {
    try {
      const result = await axiosHttp.get(
        !cat ? `following?status=A` : `following?status=A&skillCategory=${cat}`
      );
      if (result.status === 200) {
        setFollowers(result.data.data);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleApiError = (error) => {
    if (error.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(error),
        type: "error",
      });
      authContext.logout();
    } else if (error.response.status === 400) {
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(error),
        type: "error",
      });
    } else if (error.response?.status >= 500) {
      appContext.updateNotificationState({
        show: true,
        message: "Something went wrong, please try again later.",
        type: "error",
      });
    }
  };

  const handleUnFollow = async (item) => {
    setLoading(true);
    try {
      const unfollowApi = await axiosHttp.post(`un-follow/${item.id}`);
      if (unfollowApi.status === 201) {
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: `You unfollowed ${item?.fName} ${item?.lName}`,
        });
        getFollowingsList();
      }
    } catch (error) {
      handleApiError(error);
    }
    setLoading(false);
  };

  const handleWithdraw = async (item) => {
    setLoading(true);
    try {
      const unfollowApi = await axiosHttp.post(`withdraw/${item.id}`);
      if (unfollowApi.status === 201) {
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: `You ${
            item.userStatus === "followings" ? "withdrew" : "denied"
          } request to ${item?.fName} ${item?.lName}`,
        });
        getPending();
      }
    } catch (error) {
      handleApiError(error);
    }
    setLoading(false);
  };

  const handleRequest = async (userId, status, follower, tab) => {
    setLoading(true);
    try {
      const followApi = await axiosHttp.post("follow", {
        userId,
        status,
      });
      if (followApi.status === 201) {
        [followerApiStatus.accept, followerApiStatus.cancel].includes(status)
          ? dispatch(getFollowersList())
          : dispatch(getFollowerSuggestion());
        dispatch(getActiveNotificationCount());
        dispatch(getActiveChatNotificationCount());

        if (status === followerApiStatus.accept) {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `Accepted follow request from ${follower?.fName} ${follower?.lName}`,
          });
        } else if (status === followerApiStatus.cancel) {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `Cancelled follow request from ${follower?.fName} ${follower?.lName}`,
          });
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `You gave follow request to ${follower?.fName} ${follower?.lName}`,
          });
        }
        getMyFollowers();
        getPending(tab);
      }
    } catch (e) {
      handleApiError(e);
    }
    setLoading(false);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="tab-follow">
        <div className="tabbable">
          <ul className="nav nav-tabs no-wrap connection-tab  border-bottom-0">
            <li
              className={activeTab === "followers" ? "tab-heading-active" : ""}
            >
              <a onClick={(event) => tabSwitchHandler(event, "followers")}>
                <p className="text-center  post-txt mr-3">
                  Followers {`(${followers.length})` || `(${0})`}
                </p>
              </a>
            </li>
            <li
              className={
                activeTab === "followingList" ? "tab-heading-active" : ""
              }
            >
              <a onClick={(event) => tabSwitchHandler(event, "followingList")}>
                <p className="text-center  post-txt">
                  Following {`(${followingList.length})` || `(${0})`}
                </p>
              </a>
            </li>
            <li
              className={
                activeTab === "pendingList" ? "tab-heading-active" : ""
              }
            >
              <a onClick={(event) => tabSwitchHandler(event, "pendingList")}>
                <p className="text-center  post-txt">
                  Pending {`(${pendingList.length})` || `(${0})`}
                </p>
              </a>
            </li>
          </ul>
          <div className="tab-content">
            {activeTab === "followers" && (
              <div
                className={`tab-pane fade mt-4 ${
                  activeTab === "followers" ? "show active in" : ""
                }`}
              >
                {followers.length === 0 && <NoDataAvailable />}
                {followers.length > 0 &&
                  followers.map((follower, index) => (
                    <UserListView key={index} user={follower}>
                      {follower?.followStatus === "R" && (
                        <>
                          <button
                            type="button"
                            className="btn btn-primary prim-btn mr-2"
                            onClick={() =>
                              handleRequest(
                                follower.userId,
                                followerApiStatus.accept,
                                follower,
                                "followers"
                              )
                            }
                          >
                            Confirm
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary del-btn mr-2"
                            onClick={() =>
                              handleRequest(
                                follower.userId,
                                followerApiStatus.cancel,
                                follower
                              )
                            }
                          >
                            Delete
                          </button>
                        </>
                      )}
                      {follower?.isFollowingBack === false &&
                        follower?.followingBackRequest !== "R" && (
                          <button
                            type="button"
                            className="btn btn-outline-primary follow-btn mr-2"
                            onClick={() =>
                              handleRequest(
                                follower.userId,
                                followerApiStatus.request,
                                follower
                              )
                            }
                          >
                            Follow
                          </button>
                        )}
                    </UserListView>
                  ))}
              </div>
            )}
            {activeTab === "followingList" && (
              <div
                className={`tab-pane fade mt-4 ${
                  activeTab === "followingList" ? "show active in" : ""
                }`}
              >
                {followingList.length === 0 && <NoDataAvailable />}
                {followingList.length > 0 &&
                  followingList.map((followerSuggestion, index) => (
                    <UserListView key={index} user={followerSuggestion}>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn unfollow-btn"
                          onClick={() => handleUnFollow(followerSuggestion)}
                        >
                          unfollow
                        </button>
                      </div>
                    </UserListView>
                  ))}
              </div>
            )}
            {activeTab === "pendingList" && (
              <div
                className={`tab-pane fade mt-4 ${
                  activeTab === "pendingList" ? "show active in" : ""
                }`}
              >
                {pendingList.length === 0 && <NoDataAvailable />}
                {pendingList.length > 0 &&
                  pendingList.map((followerSuggestion, index) => (
                    <UserListView key={index} user={followerSuggestion}>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn unfollow-btn"
                          onClick={() => handleWithdraw(followerSuggestion)}
                        >
                          {followerSuggestion.userStatus === "followings"
                            ? "Withdraw"
                            : "deny"}
                        </button>
                        {followerSuggestion?.userStatus === "followers" && (
                          <button
                            type="button"
                            className="btn btn-primary prim-btn mr-4"
                            onClick={() =>
                              handleRequest(
                                followerSuggestion.userId,
                                followerApiStatus.accept,
                                followerSuggestion,
                                "pendingList"
                              )
                            }
                          >
                            Accept
                          </button>
                        )}
                      </div>
                    </UserListView>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="disp-only-in-mob">
        <SuggestForYou
          path={location.pathname}
          followerSuggestionList={followers}
        />
      </div>
    </>
  );
};

export default ProfileActivity;
